
import { Card, Typography } from "antd";
import { StopOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import "../Pages/CSS/DonnesBases.css";
import SuspensionsCons from "./SuspensionsCons";
import SuspensionsOpt from "./SuspensionsOpt";
import ChargesIPM from "./ChargesIPM";
import SuspensionsEndettement from "./SuspensionsEndettement";


const { Title } = Typography;

const tabList = [
  {
    key: "1",
    label: "Frais Réels Engagés ",
  },
  {
    key: "2",
    label: "Optiques",
  },
  {
    key: "3",
    label: "Charges IPM",
  },
  {
    key: "4",
    label: "Endettement",
  },
];

const Suspensions = () => {

  const [activeTabKey2, setActiveTabKey2] = useState(tabList[0].key);


  const onTab2Change = (key) => {
    setActiveTabKey2(key);
  };

  const getActiveTabLabel = () => {
    const activeTab = tabList.find(tab => tab.key === activeTabKey2);
    return activeTab ? activeTab.label : '';
  };


  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <StopOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
          }}
        >
          Suspensions - {getActiveTabLabel()}
        </span>
      </div>
      <Card
        style={{
          width: "100%",
        }}
        tabList={tabList}
        activeTabKey={activeTabKey2}
        onTabChange={onTab2Change}
        tabProps={{
          size: "middle",
        }}
      >
        {activeTabKey2 === "1" && <SuspensionsCons />}
        {activeTabKey2 === "2" && <SuspensionsOpt />}
        {activeTabKey2 === "3" && <ChargesIPM />}
        {activeTabKey2 === "4" && <SuspensionsEndettement />}

      </Card>
    </div>
  );
};

export default Suspensions;
